import { render } from "./YourVehicle.vue?vue&type=template&id=8b833832&scoped=true"
import script from "./YourVehicle.vue?vue&type=script&lang=js"
export * from "./YourVehicle.vue?vue&type=script&lang=js"

import "./YourVehicle.vue?vue&type=style&index=0&id=8b833832&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b833832"]])

export default __exports__